const layout = {
  header: {
    changeView: {
      toasts: {
        success: 'האתר שונה בהצלחה',
        failure: 'אירעה שגיאה בלתי צפויה',
      },
    },
  },

  sideBar: {
    menu: {
      home: {
        title: 'בית',
      },
      parents: {
        title: 'הורים',
      },
      trips: {
        title: 'נסיעות',
        children: {
          trips: 'נסיעות',
          timeline: 'ציר זמן',
          feedbacks: 'משובים',
        },
      },
      jobs: {
        title: 'הזמנות',
        children: {
          jobs: 'הזמנות',
          calendar: 'לוח שנה',
          passengers: 'נוסעים',
          students: 'תלמידים',
          employees: 'עובדים',
          profiles: 'פרופילים',
          parents: 'הורים',
          caregivers: 'מטפלים',
        },
      },
      drivers: {
        title: 'נהגים',
        children: {
          drivers: 'נהגים',
          onlineDrivers: 'נהגים מקוונים',
          driverShifts: 'משמרות נהגים',
          driverShiftsTemplates: 'תבניות משמרות',
          livemap: 'מפה חיה',
        },
      },
      vehicles: {
        title: 'רכבים',
      },
      integrations: {
        title: 'אינטגרציות',
      },
      automations: {
        title: 'אוטומציות',
      },
      reports: {
        title: 'דוחות',
      },
      more: {
        title: 'עוד',
        children: {
          areas: 'אזורים',
          attributes: 'מאפיינים',
          blacklist: 'כרטיסי תשלום חסומים',
          extraServices: 'שירותים נוספים',
          fares: 'דמי נסיעה',
          holidays: 'חגים',
          locations: 'מיקומים',
          permissions: 'תפקידים והרשאות',
          profiles: 'פרופילים',
          rates: 'תעריפים',
          services: 'שירותים',
          shifts: 'משמרות',
          shuttles: 'שאטלים',
          sites: 'אתרים',
          suppliers: 'ספקים',
          settings: 'הגדרות מערכת',
          uploadData: 'העלאת נתונים',
          users: 'משתמשים',
          apiKeys: 'מפתחות API',
          customRules: 'כללים מותאמים',
          facilities: 'מתקנים',
          roiSimulation: 'סימולציית ROI',
        },
      },
    },
    settings: {
      myProfile: {
        button: 'הפרופיל שלי',
      },
      languages: {
        button: 'שפות',
      },
      themes: {
        button: 'ערכת נושא',
        options: {
          light: 'בהיר',
          dark: 'כהה',
        },
      },
      logout: 'התנתק',
    },
  },

  footer: {
    poweredBy: 'מופעל על ידי',
    moovex: 'Moovex',
  },

  asideQueue: {
    headerQueue: 'תור',
    empty: 'לא נמצאו הזמנות בתור',
    btnRemove: 'הסר מהתור',
    btnAssign: 'העבר לנסיעה',
  },
};

export default layout;
